module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_4.93c49a7c.png";